<template>
  <div>
    <ProducaoBar
      :is-midias-moderacao="false"
      :cod_pasta="cod_pasta"
      :selected-tab-number="2"
    />
    <v-row class="ma-0 pa-5">
      <v-col>
        <EnquetesRecebidas
          v-if="cod_producao && enquetesProducao"
          :data="enquetesProducao"
          :cod_producao="cod_producao"
          :current-enquetes-page="page"
        />
        <v-pagination
          v-if="enquetesProducao"
          class="mt-5"
          v-model="page"
          :length="enquetesProducao.totalPages || 1"
          @input="handleAprovadasPageChange"
          :total-visible="paginasExibidas"
        />
      </v-col>
      <v-col>
        <EnqueteEmExibicao
          v-if="cod_producao && cod_portal"
          :enquete-em-exibicao="enqueteEmExibicao"
          :cod_producao="cod_producao"
          :aprovadas_current_page="page"
        />
        <v-pagination
          v-if="cod_producao && cod_portal && enqueteEmExibicao"
          class="mt-5"
          v-model="pageModerada"
          :length="1"
          @input="handleModeradasPageChange"
          :total-visible="paginasExibidas"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ProducaoBar from "../components/Producao/ProducaoBar.vue";
import EnquetesRecebidas from "../components/Enquetes/EnquetesRecebidas.vue";
import EnqueteEmExibicao from "../components/Enquetes/EnqueteEmExibicao.vue";

const TIMER_ENQUETES_LIST_INTERVAL = 30000;
const TIMER_ENQUETE_DISPLAY_INTERVAL = 5000;
const TIMER_TARJA_CONFIG_INTERVAL = 2000;

export default {
  name: "EnquetesView",
  components: {
    ProducaoBar,
    EnquetesRecebidas,
    EnqueteEmExibicao,
  },
  data() {
    return {
      isDark: this.$vuetify.theme.dark,
      cod_producao: this.$store.state.producoes.selectedProducao?.cod_producao || null,
      cod_portal: this.$store.state.enquetes.selectedPortal || null,
      page: 1,
      pageModerada: 1,
      size: 5,
      paginasExibidas: 9,
      timerAprovada: null,
      timerModerada: null,
      timerTarja: null,
      cod_pasta: null,
    };
  },
  beforeCreate() {
    this.$store.commit("moderacao/setModoModeracao", 2);
    this.$vuetify.theme.themes.dark = this.$vuetify.theme.framework.theme.defaults.dark;
    this.$vuetify.theme.themes.light = this.$vuetify.theme.framework.theme.defaults.light;
  },
  async created() {
    this.setFiltroEnquetes(
      localStorage.getItem("@socialcam/filtro_texto_enquetes") ?? null
    );

    if (this.cod_producao && this.cod_portal) {
      await Promise.all([
        this.getPortaisEnquetes(),
        this.getCategoriasPorPortal({ id_portal: this.cod_portal }),
        this.getEnquetesProducao({
          cod_producao: this.cod_producao,
          size: this.size,
          page: this.page,
          cod_portal: this.cod_portal,
          id_categoria: this.$store.state.enquetes.selectedCategoria,
          filtro_texto: this.filtroEnquetes,
        }),
        this.getEnqueteEmExibicao({ cod_producao: this.cod_producao }),
        this.getConfigTarja({ cod_producao: this.cod_producao }),
      ]);
      this.updateTimers();
    }
  },
  methods: {
    ...mapActions({
      getEnquetesProducao: "enquetes/getEnquetesProducao",
      getEnqueteEmExibicao: "enquetes/getEnqueteEmExibicao",
      setFiltroEnquetes: "enquetes/setFiltroEnquetes",
      getProducoes: "producoes/getProducoes",
      getPastas: "pastas/getPastas",
      getPortaisEnquetes: "enquetes/getPortaisEnquetes",
      getCategoriasPorPortal: "enquetes/getCategoriasPorPortal",
      getConfigTarja: "tarja_enquete/getConfigTarjaEnquete",
    }),
    changeTheme(e) {
      localStorage.setItem("@socialcam/is_dark_theme", e);
      this.$vuetify.theme.dark = e;
    },
    async changePasta(cod_pasta) {
      this.cod_pasta = cod_pasta;
      this.updateTimers();
    },
    async handleAprovadasPageChange(newPage) {
      this.page = newPage;
      await this.getEnquetesProducao({
        cod_producao: this.cod_producao,
        cod_portal: this.cod_portal,
        page: newPage,
        size: this.size,
        filtro_texto: this.filtroEnquetes,
        id_categoria: this.$store.state.enquetes.selectedCategoria,
      });
      window.scrollTo({ top: 0, behavior: "smooth" });
      this.updateTimers();
    },
    async handleModeradasPageChange(newPage) {
      this.pageModerada = newPage;

      await this.getEnqueteEmExibicao({
        cod_producao: this.cod_producao,
        cod_portal: this.cod_portal,
        page: newPage,
      });
      window.scrollTo({ top: 0, behavior: "smooth" });
      this.updateTimers();
    },

    updateTimers() {
      clearInterval(this.timerAprovada);
      clearInterval(this.timerModerada);
      clearInterval(this.timerTarja);

      // Timer for EnquetesRecebidas
      this.timerAprovada = setInterval(async () => {
        const cod_producao = this.$store.state.producoes.selectedProducao?.cod_producao;

        if (cod_producao) {
          try {
            await this.getEnquetesProducao({
              cod_producao: cod_producao,
              size: this.size,
              page: this.$store.state.enquetes.enquetesProducao?.currentPage || this.page,
              cod_portal: this.$store.state.enquetes.selectedPortal,
              id_categoria: this.$store.state.enquetes.selectedCategoria,
              filtro_texto: this.filtroEnquetes,
            });
          } catch (error) {
            console.error("Error refreshing EnquetesRecebidas:", error);
          }
        }
      }, TIMER_ENQUETES_LIST_INTERVAL);

      // Timer for EnqueteEmExibicao
      this.timerModerada = setInterval(async () => {
        const cod_producao = this.$store.state.producoes.selectedProducao?.cod_producao;

        if (cod_producao) {
          try {
            await this.getEnqueteEmExibicao({
              cod_producao: cod_producao,
            });
          } catch (error) {
            console.error("Error refreshing EnqueteEmExibicao:", error);
          }
        }
      }, TIMER_ENQUETE_DISPLAY_INTERVAL);

      // Timer for Tarja configuration
      this.timerTarja = setInterval(async () => {
        const cod_producao = this.$store.state.producoes.selectedProducao?.cod_producao;

        if (cod_producao) {
          try {
            await this.getConfigTarja({
              cod_producao: cod_producao,
            });
          } catch (error) {
            console.error("Error refreshing ConfigTarja:", error);
          }
        }
      }, TIMER_TARJA_CONFIG_INTERVAL);
    },
  },
  computed: {
    ...mapGetters({
      dark_theme: "themes/getTheme",
      enquetesProducao: "enquetes/getterEnquetesProducao",
      enqueteEmExibicao: "enquetes/getterEnqueteEmExibicao",
      filtroEnquetes: "enquetes/getterFiltroEnquetes",
    }),
  },
  watch: {
    "$store.state.producoes.selectedProducao": async function (newValue) {
      if (!newValue || !newValue.cod_producao) {
        this.cod_producao = null;
        return;
      }

      this.cod_producao = newValue.cod_producao;
      this.page = 1;

      if (this.cod_portal) {
        try {
          await this.getPastas({ cod_producao: this.cod_producao });
          await this.getEnqueteEmExibicao({
            cod_producao: this.cod_producao,
          });
          await this.getConfigTarja({
            cod_producao: this.cod_producao,
          });
          this.updateTimers();
        } catch (error) {
          console.error("Error loading production data:", error);
          this.$toast.error("Erro ao carregar dados da produção");
        }
      }
    },
    "$store.state.enquetes.selectedPortal": async function (newValue) {
      this.cod_portal = newValue;
      this.page = 1;

      const selectedProducao = this.$store.state.producoes.selectedProducao;
      if (!selectedProducao || !selectedProducao.cod_producao) {
        return;
      }

      try {
        await this.getCategoriasPorPortal({ id_portal: newValue });
        await this.getEnquetesProducao({
          cod_producao: selectedProducao.cod_producao,
          size: this.size,
          page: this.$store.state.enquetes.enquetesProducao?.currentPage || this.page,
          cod_portal: this.$store.state.enquetes.selectedPortal,
          id_categoria: this.$store.state.enquetes.selectedCategoria,
          filtro_texto: this.filtroEnquetes,
        });

        this.updateTimers();

        if (this.cod_producao) {
          await this.getEnqueteEmExibicao({
            cod_producao: this.cod_producao,
          });
          await this.getConfigTarja({
            cod_producao: this.cod_producao,
          });
        }
      } catch (error) {
        console.error("Error loading portal data:", error);
        this.$toast.error("Erro ao carregar dados do portal");
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.timerAprovada);
    clearInterval(this.timerModerada);
    clearInterval(this.timerTarja);
  },
};
</script>

<style lang="scss" scoped></style>
